module.exports = __webpack_public_path__ + "b87196a5e043b4c1f9d282dddd65dad2.svg";